/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import extensionProbe_IconURL from '../RAISE_Logo.png';
import extensionProbe_InsetIconURL from '../PRG_Logo.png';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Extension Probe"
        description="name for the Extension Probe extension"
        id="extension.extensionProbe.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="(INTERNAL) Use this extension to probe the info of other estensions"
        description="description for the Extension Probe extension"
        id="extension.extensionProbe.description"
    />
  ),
	tags: ["PRG Internal"],
	featured: true,
	extensionId: 'extensionProbe',
	iconURL: extensionProbe_IconURL,
	insetIconURL: extensionProbe_InsetIconURL,
}